import { gql, useMutation } from '@apollo/client';

export const REVOKE_DELIVERY = gql`
  mutation RevokeDelivery($trackingNumber: String!, $revokeReason: DeliveryRevokeReason!) {
    revokeDelivery(trackingNumber: $trackingNumber, revokeReason: $revokeReason)
  }
`;

export function useRevokeDelivery() {
    return useMutation<{ revokeDelivery: boolean }, { trackingNumber: string; revokeReason: string }>(
        REVOKE_DELIVERY
    );
}
